export function formatDecimalSv(v, opts = {}) {
    if (v === null || v === undefined || v === '') return ''
    const n = Number(String(v).replace(',', '.'))
    if (Number.isNaN(n)) return String(v) // lämna som-is om det inte är tal
    const { minimumFractionDigits, maximumFractionDigits } = opts
    return new Intl.NumberFormat('sv-SE', { minimumFractionDigits, maximumFractionDigits }).format(n)
}